/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './tabs.stache';
import urlUtil from 'scripts/utils/url';
import can from 'can';
import dtm from 'scripts/services/dtm';
import appContext from 'scripts/app-context';

const kpis = [
    { value: 'driving-distance', title: 'Driving Distance' },
    { value: 'fairways-hit', title: 'Fairways Hit' },
    { value: 'greens-in-regulation', title: 'Greens in Regulation' },
    { value: 'putting', title: 'Putting' },
    { value: 'birdies', title: 'Birdies' },
    { value: 'eagles', title: 'Eagles' },
];

Component.extend({
    tag: 'history-experience-scoring-and-stats-tabs',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            years: {
                Type: can.List,
                Value: can.List,
            },
            kpis: {
                Type: can.List,
                Value: null,
            },
            kpi: {
                type: 'string',
                value: 'driving-distance',
            },
            yearSelected: {
                type: 'string',
                value: new Date().getFullYear(),
            },
        },

        init() {
            if (this.attr('type') == 'history-experience-stats') {
                this.attr('kpis', kpis);
            }
        },

        handleRoutes(options) {
            let year, kpi;
            if (!options) {
                year = urlUtil.getHashValue('y') || this.attr('yearSelected');
                kpi = urlUtil.getHashValue('s') || this.attr('kpi');

                if (year) {
                    this.attr('yearSelected', year);
                }
                if (kpi) {
                    this.attr('kpi', kpi);
                }
            } else {
                year = options.year || this.attr('yearSelected');
                kpi = options.kpi;
            }

            can.route.attr({
                y: this.attr('yearSelected'),
            });

            if (this.attr('type') == 'history-experience-stats') {
                can.route.attr({
                    s: this.attr('kpi') || null,
                });
            }
        },
    },
    events: {
        inserted() {
            appContext.model.bind(
                'history-experience-scoring-and-stats-years-ready',
                this.fillYears.bind(this),
            );
            appContext.model.bind(
                'history-experience-stats-ready',
                this.handleStatsReady.bind(this),
            );

            can.route.ready();

            this.viewModel.handleRoutes();
        },

        fillYears(event, years) {
            if (years && years.length) {
                this.viewModel.attr('years', years);
                this.viewModel.attr('yearSelected', years[0]);
            }
            appContext.model.dispatch(
                'history-experience-scoring-and-stats-years-change',
                [this.viewModel.attr('yearSelected')],
            );
        },

        handleStatsReady(event) {
            appContext.model.dispatch('history-experience-stats-kpi-change', [
                this.viewModel.attr('kpi'),
            ]);
        },

        '{scope} yearSelected'(scope, event, yearSelected) {
            this.viewModel.handleRoutes({ year: yearSelected });
            dtm.trackHistoryTimelineYearSelection(yearSelected);
            appContext.model.dispatch(
                'history-experience-scoring-and-stats-years-change',
                [yearSelected],
            );
        },

        '{scope} kpi'(scope, event, kpi) {
            this.viewModel.handleRoutes({ kpi: kpi });
            dtm.trackHistoryTimelineTagSelection(kpi);
            appContext.model.dispatch('history-experience-stats-kpi-change', [
                kpi,
            ]);
        },
    },
    helpers: {
        isActive(options) {
            return location.href.indexOf(options.context.url) != -1
                ? 'is-active'
                : '';
        },
    },
});
